import { Eye, MicOff, ScissorsLineDashed, Scissors, RadioTower, Clock } from "lucide-react";
import type { EditAction } from "../helpers/focusViewTypes";

interface EditActionsBarProps {
  activeActions: Record<EditAction, boolean>;
  onToggle: (action: EditAction) => void;
  allMissed: boolean;
}

const ACTIONS: { key: EditAction; icon: React.ReactNode; label: string }[] = [
  { key: "blur", icon: <Eye size={14} />, label: "Blur face/region" },
  { key: "mute", icon: <MicOff size={14} />, label: "Mute audio" },
  { key: "mask", icon: <ScissorsLineDashed size={14} />, label: "Mask region" },
  { key: "cut", icon: <Scissors size={14} />, label: "Cut segment" },
];

export function EditActionsBar({ activeActions, onToggle, allMissed }: Readonly<EditActionsBarProps>) {
  return (
    <div className="fv-section-body">
      <div className="text-xs font-semibold text-gray-900 mb-2.5">Edit Recording</div>

      <div className="flex flex-wrap gap-2">
        {ACTIONS.map(({ key, icon, label }) => {
          const active = activeActions[key];
          return (
            <button
              key={key}
              type="button"
              onClick={() => onToggle(key)}
              className={`flex items-center gap-1.5 px-3.5 py-2 rounded-[7px] text-xs font-medium border transition-colors ${
                active
                  ? "bg-blue-50 text-blue-700 border-blue-600"
                  : "bg-gray-100 text-gray-500 border-gray-300 hover:bg-gray-200/70"
              }`}
            >
              {icon}
              {label}
            </button>
          );
        })}
      </div>

      {allMissed && (
        <div className="flex items-center gap-1.5 text-[11px] text-amber-700 mt-1.5">
          <RadioTower size={13} />
          Live stream has passed all flagged segments — edits will apply to archive only.
        </div>
      )}

      {!allMissed && (
        <div className="flex items-center gap-1.5 text-[11px] text-gray-400 mt-1.5" style={{ display: "none" }}>
          <Clock size={13} />
          Edit window closed.
        </div>
      )}
    </div>
  );
}
